import type { CommandInterface } from "./CommandInterface"
import type { BambuClient } from "src/BambuClient"
import { CommandResponse } from "../types"
import { getSequenceId, isValidSequenceId, PROJECT_FILE_SEQUENCE_ID } from "../utils/sequenceIdManager"

export abstract class AbstractCommand implements CommandInterface {
	public abstract category: CommandInterface["category"]
	public abstract command: CommandInterface["command"]

	/**
	 * Constructs a basic command class with the properties required for basic compatibility with @hiv3d/bambu-node.
	 * @param extra Extra properties to add to the request object.
	 */
	protected constructor(public extra: CommandInterface["extra"] = {}) {}

	public async invoke(client: BambuClient): Promise<string> {
		const { sequence_id, ...rest } = this.extra || {}

		// Get a valid sequence ID, either from provided string or generate new one
		const numericId = sequence_id ? parseInt(sequence_id, 10) : null
		const isProjectFilePrint = this.category === "print" && this.command === "project_file"
		
		// Use PROJECT_FILE_SEQUENCE_ID if it's explicitly provided for project file printing
		const finalSequenceId = 
			(isProjectFilePrint && numericId === PROJECT_FILE_SEQUENCE_ID) ? PROJECT_FILE_SEQUENCE_ID :
			(numericId && !isNaN(numericId) && isValidSequenceId(numericId)) ? numericId :
			getSequenceId()

		const rawMessage = {
			[this.category]: {
				sequence_id: finalSequenceId.toString(),
				command: this.command,
				...rest,
			},
		}

		await client.publish(rawMessage)
		
		return finalSequenceId.toString()
	}

	public abstract ownsResponse(command: CommandResponse, squence_id?: string): boolean
}
